module.exports = __webpack_public_path__ + "static/media/IMG_2639.276a39ea.jpg";